export const card = "border-dashed border-slate-300 dark:border-slate-700";
export const searchInput =
  "w-full pl-10 pr-4 py-2.5 text-sm rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-colors";
export const marketplaceBadge =
  "shrink-0 inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-lg bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-800";
export const panelBorder =
  "border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden";
export const panelHeader =
  "px-3 py-2 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700";
export const resultRow =
  "flex items-center justify-between px-3 py-2.5 cursor-pointer transition-colors";
export const resultRowSelected = "bg-indigo-50 dark:bg-indigo-950/40";
export const resultRowHover = "hover:bg-slate-50 dark:hover:bg-slate-800/50";
export const selectedInfoCard =
  "p-3 rounded-lg bg-indigo-50/60 dark:bg-indigo-950/30 border border-indigo-100 dark:border-indigo-900/50 space-y-1.5";
export const digestPreview =
  "rounded-md bg-slate-950 p-3 font-mono text-[10px] leading-relaxed max-h-[180px] overflow-y-auto space-y-1";
export const runBlock =
  "rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden animate-in fade-in slide-in from-bottom-2 duration-300";
export const runHeader =
  "px-4 py-3 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between";
